import styled from 'styled-components'

import ActionButton from '../../components/ActionButton'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  flex-grow: 1;
  padding: 20px;
`

export const Title = styled.p`
  ${({ theme }) => theme.textStyles.titleH1};
`

export const Description = styled.p`
  ${({ theme }) => theme.textStyles.body};
  margin-top: 20px;
  text-align: center;
`

export const Cta = styled(ActionButton)`
  ${({ theme }) => theme.textStyles.body};
  margin-top: 16px;
  width: auto;
  height: auto;
  text-decoration: underline;
  text-transform: none !important;
`
